const publicKeyPem = process.env.REACT_APP_ENCRYPTION_KEY;

// `-----BEGIN PUBLIC KEY-----
// // MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgHUd3eM0tL37TSO5CKytF5ah2BzK
// // TnE0m1OykEO0kcc1Ab3qClKK1dbaw8FPd0y2R7NdEVlduTGHh4B0eHH3Opn1aqkT
// // 6+/5E8u6r1Slym4JQdi6kg9q6kwd1gUN9PrdRHyzrCJjrPq3e2LRB3gXn0Qf9Pks
// // PYIPC/WiTFykaRKhAgMBAAE=
// // -----END PUBLIC KEY-----`;

export default publicKeyPem;
